import ApiBase from '../../../api-base'
import { ACTIVE_BASE_REST } from '../../../constants'
export default class FurnitureEmployeeTariff extends ApiBase {
  constructor(store) {
    const path = ACTIVE_BASE_REST + '/tariff/furniture/employee'
    super(store, path)
  }
}
